export const local = {
  set (key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  },
  get (key) {
    return JSON.parse(localStorage.getItem(key))
  },
  remove (key) {
    localStorage.removeItem(key)
  }
}
export const session = {
  set (key, value) {
    if(key == 'channel_id'){
      value = 1
    }
    sessionStorage.setItem(key, JSON.stringify(value))
  },
  get (key) {
    if(key == 'channel_id'){
      return 1;
    }
    if(key == 'lang'){
      return 'cn'
    }
    return JSON.parse(sessionStorage.getItem(key))
  },
  remove (key) {
    sessionStorage.removeItem(key)
  }
}
